import { clientWindow } from "./dom";
import {
  YOO_FINDS_USER_INFO,
  YOO_FINDS_TOKEN,
  YOO_FINDS_CLIENT_INFO,
  YOO_FINDS_UID_KEY,
  YOO_FINDS_AD_TASKS_TIP_SHOW,
} from "@/common";
import { ClientInfo, TUserInfo } from "@/typings";

/**
 * localStorage 获取客户端信息
 * @returns 客户端信息
 */
export const getStorageClientInfo = (): ClientInfo | undefined => {
  try {
    const clientInfo = clientWindow?.localStorage.getItem(
      YOO_FINDS_CLIENT_INFO
    );
    return clientInfo ? JSON.parse(clientInfo) : undefined;
  } catch {
    return undefined;
  }
};

/**
 * localStorage 获取token
 * @returns token
 */
export const getStorageToken = () => {
  const token = clientWindow?.localStorage.getItem(YOO_FINDS_TOKEN);
  return token || undefined;
};

/**
 * localStorage 获取用户信息
 * @returns 用户信息
 */
export const getStorageUserInfo = (): TUserInfo | undefined => {
  try {
    const userInfo = clientWindow?.localStorage.getItem(YOO_FINDS_USER_INFO);
    return userInfo ? JSON.parse(userInfo) : undefined;
  } catch {
    return undefined;
  }
};

/**
 * localStorage 获取用户uid
 * @returns 用户uid
 */
export const getStorageUid = () => {
  const uid = getStorageUserInfo()?.uid;
  return uid || undefined;
};

export const getDeviceId = () => {
  return localStorage.getItem(YOO_FINDS_UID_KEY);
};

export const setDeviceId = (uid: string) => {
  localStorage.setItem(YOO_FINDS_UID_KEY, uid);
};

export const setStorageToken = (token: string) => {
  localStorage.setItem(YOO_FINDS_TOKEN, token);
};

export const setStorageAdTasksTipShow = (show: boolean) => {
  localStorage.setItem(YOO_FINDS_AD_TASKS_TIP_SHOW, show.toString());
};

export const getStorageAdTasksTipShow = () => {
  return localStorage.getItem(YOO_FINDS_AD_TASKS_TIP_SHOW) === "true";
};
